export default __webpack_public_path__ + "media/flavours/glitch/images/logo_warn_glitch.svg";